import { Modal } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import {
  createPendingBooking,
  createReservations,
  deleteBooking,
  deleteReservation,
  editBooking,
  refundBooking,
  UpdateReservation,
} from 'actions/booking';
import { setLastUsedDepositDetails, showAlert } from 'actions/client';
import { fetchAllMenus } from 'actions/venue';
import ConfirmationDialog from 'components/Utility/Dialogs/ConfirmationDialog';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Loader } from 'react-overlay-loader';
import { connect } from 'react-redux';
import {
  change,
  getFormValues,
  initialize,
  isValid,
  reduxForm,
  reset,
} from 'redux-form';
import { multiplyValueForCurrency } from 'utils/currency/currency-utils';
import { fetchMenuList } from '../../../../../../actions/menus';
import ContactDetailsForm from './ContactDetailsForm';

class BookingDetailsModal extends React.Component {
  state = {
    formPage: 0,
    showDeleteConfirmation: false,
    showDeleteWithRefundConfirmation: false,
    showRefundConfirmation: false,
    attachedMenus: [],
    isPhoneNumberValid: true,
  };

  constructor(props) {
    super(props);
    this.handleAttachedMenus = this.handleAttachedMenus.bind(this);
  }

  handleAttachedMenus(attachedMenus) {
    this.setState({ attachedMenus });
  }

  componentWillMount() {
    this.props.fetchMenuList();
  }

  componentWillUpdate(nextProps, nextState) {
    const nextBooking = nextProps.booking || undefined;

    if (!this.props.open && this.state.formPage !== 0) {
      this.setState({ formPage: 0 });
    }

    if (!this.props.open && nextProps.open) {
      this.props.dispatch(
        initialize(
          'bookingDetails',
          convertBookingToForm(
            nextBooking,
            this.props.venue.currency,
            this.props.lastUsedDepositDetails
          ),
          false
        )
      );
    }

    if (!nextProps.creatingBooking && this.props.creatingBooking) {
      if (nextProps.bookingCreated && !this.props.bookingCreated) {
        this.showBookingCreated();
        this.props.onComplete();
      } else {
        if (nextProps.creatingBookingErr === 'timeout') {
          this.showCreationError(
            'Poor Internet Connectivity',
            'Your internet connection appears to be slow or offline. This booking will be uploaded in the background.'
          );

          this.props.onComplete(false);
        } else if (nextProps.creatingBookingErr !== null) {
          this.showCreationError(
            null,
            `We could not create this booking: ${nextProps.creatingBookingErr}`
          );
        } else {
          this.showCreationError();
        }
      }
    }

    if (!nextProps.editingBooking && this.props.editingBooking) {
      if (nextProps.bookingEdited && !this.props.bookingEdited) {
        this.showBookingEdited();
        this.props.onComplete();
      } else {
        this.showBookingEditError();
      }
    }

    if (!nextProps.deletingBooking && this.props.deletingBooking) {
      if (nextProps.bookingDeleted && !this.props.bookingDeleted) {
        this.showBookingDeleted();
        this.props.onComplete();
      } else {
        this.showBookingDeleteError();
      }
    }

    if (!nextProps.refundingBooking && this.props.refundingBooking) {
      if (nextProps.bookingRefunded && !this.props.bookingRefunded) {
        this.showBookingRefunded();
        this.props.onComplete();
      } else {
        this.showBookingRefundedError();
      }
    }
  }

  // Form Navigation

  handleChange = (event, formPage) => {
    this.setState({ formPage });
  };

  closeForm = () => {
    this.setState({ isPhoneNumberValid: true });
    this.props.dispatch(reset('bookingDetails'));
    this.props.onClose();
  };

  nextPage = () => this.setState({ formPage: this.state.formPage + 1 });

  previousPage = () => this.setState({ formPage: this.state.formPage - 1 });

  // Booking Actions

  editBooking = () => {
    if (this.props.formValid) {
      const data = this.sanitizeFormValues(this.props.formValues);
      this.props.editBooking({ booking: data });
    } else {
      this.showFormError();
    }
  };

  editReservation = () => {
    this.setState({ loading: true });
    if (this.props.formValid) {
      const data = this.sanitizeFormValues(this.props.formValues);
      delete data.venue_id;
      data.reservation_id = this.props.booking.id;

      const reservationTime = this.props.formValues['booking_time'];
      if (!reservationTime) {
        this.showFormError(
          'You are missing the reservation date, make sure you choose todays date or onwards.'
        );
        this.setState({ loading: false });
        return;
      }
      const phone = this.props.formValues['phone'];
      if (!this.state.isPhoneNumberValid || !phone) {
        this.showFormError('Please double check the phone number.');
        this.setState({ loading: false });
        return;
      }

      this.props.updateReservation(data).then(() => {
        this.props.fetchReservations(this.props.venue._id).then(() => {
          this.props.onClose();
          this.props.onComplete();
          this.setState({ loading: false });
        });
      });
    } else {
      this.showFormError();
    }
  };

  deleteBooking = applyRefund => {
    this.hideDeleteWithRefundConfirmation();
    this.props.deleteBooking(this.props.booking.id, applyRefund);
  };

  deleteReservation = () => {
    this.setState({ loading: true });
    this.hideDeleteConfirmation();
    this.props.deleteReservation(this.props.booking.id).then(() => {
      this.props.fetchReservations(this.props.venue._id).then(() => {
        this.props.onClose();
        this.props.onComplete();
        this.setState({ loading: false });
      });
    });
  };

  refundBooking = () => {
    this.hideRefundConfirmation();
    this.props.refundBooking(this.props.booking.id);
  };

  createBooking = () => {
    if (this.props.formValid) {
      this.props.setLastUsedDepositDetails(
        this.props.formValues['force_deposit']
      );

      const data = this.sanitizeFormValues(this.props.formValues);
      this.props.createBooking({ booking: data });
    } else {
      this.showFormError();
    }
  };

  createReservation = () => {
    const reservationTime = this.props.formValues['booking_time'];
    if (!reservationTime) {
      this.showFormError(
        'You are missing the reservation date, make sure you choose todays date or onwards.'
      );
      return;
    }
    const phone = this.props.formValues['phone'];
    if (!this.state.isPhoneNumberValid || !phone) {
      this.showFormError('Please double check the phone number.');
      return;
    }

    this.setState({ loading: true });
    if (this.props.formValid) {
      this.props.setLastUsedDepositDetails(
        this.props.formValues['force_deposit']
      );

      const data = this.sanitizeFormValues(this.props.formValues);
      this.props.createReservations(data).then(() => {
        this.props.fetchReservations(this.props.venue._id).then(() => {
          this.props.onClose();
          this.props.onComplete();
          this.setState({ loading: false });
          this.showReservationConfirmedModal();
        });
      });
    } else {
      this.setState({ loading: false });
      this.showFormError();
    }
  };

  sanitizeFormValues = formValues => {
    const newFormValues = {};
    newFormValues['venue_id'] = this.props.venue._id;
    newFormValues['customer_name'] = formValues['name'];
    newFormValues['email'] = formValues['email'];

    // only accept float values for deposit amount
    newFormValues['deposit_amount'] = parseFloat(formValues['amount']) * 100;

    newFormValues['guest_count'] = parseInt(formValues['guest_count']);
    newFormValues['phone_number'] = formValues['phone'];
    newFormValues['notes'] = formValues['notes'];
    newFormValues['reserved_from'] = moment(
      formValues['booking_time']
    ).toISOString();
    newFormValues['attached_menus'] = this.state.attachedMenus;

    return newFormValues;
  };

  // Alerts

  showFormError = errorMsg => {
    if (errorMsg) {
      this.props.showAlert('Invalid Details', errorMsg);
      return;
    }
    this.props.showAlert(
      'Invalid Details',
      'You are missing some required fields.'
    );
  };

  showCreationError = (title, desc) => {
    this.props.showAlert(
      title || 'A Problem Occurred',
      desc || 'We could not create the booking. Try again later.'
    );
  };

  showBookingCreated = () => {
    this.props.showAlert(
      'Created Booking',
      'Successfully created booking. The customer has received an email.'
    );
  };

  showBookingEdited = () => {
    this.props.showAlert('Booking Edited', 'Successfully edited booking.');
  };

  showBookingEditError = () => {
    this.props.showAlert(
      'Could not edit booking',
      'Failed to edit booking. Please try again later.'
    );
  };

  showBookingDeleted = () => {
    this.props.showAlert('Booking Deleted', 'Successfully deleted booking.');
  };

  showBookingDeleteError = () => {
    this.props.showAlert(
      'Could not delete booking',
      'Failed to delete booking. Please try again later.'
    );
  };

  showBookingRefunded = () => {
    this.props.showAlert('Booking Refunded', 'Successfully refunded booking.');
  };

  showBookingRefundedError = () => {
    this.props.showAlert(
      'Could not refund booking',
      'Failed to refund booking. Please try again later.'
    );
  };

  // Confirmations

  showRefundConfirmation = () =>
    this.setState({ showRefundConfirmation: true });

  hideRefundConfirmation = () =>
    this.setState({ showRefundConfirmation: false });

  showDeleteConfirmation = () =>
    this.setState({ showDeleteConfirmation: true });

  showDeleteWithRefundConfirmation = () => {
    this.hideDeleteConfirmation();

    if (!this.props.booking.pending && this.props.booking.refunded === 0) {
      this.setState({ showDeleteWithRefundConfirmation: true });
    } else {
      this.deleteBooking(false);
    }
  };

  showReservationConfirmedModal = () => {
    this.setState({
      showModal: true,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  hideDeleteWithRefundConfirmation = () =>
    this.setState({ showDeleteWithRefundConfirmation: false });

  hideDeleteConfirmation = () =>
    this.setState({ showDeleteConfirmation: false });

  render() {
    const formPage = this.state.formPage;

    const iqosFriendly = this.props.venue.iqos_friendly;
    const editMode = this.props.booking ? true : false;
    const pendingBooking = editMode ? this.props.booking.pending : true;
    const isReservatiodPaid = editMode ? this.props.booking.paid_at : false;
    const customerName = editMode
      ? false
      : this.sanitizeFormValues(this.props.formValues).customer_name;

    const title = editMode ? 'Edit Reservation' : 'Create a Reservation';

    return (
      <div>
        <Dialog
          fullWidth={true}
          disableEscapeKeyDown={true}
          fullScreen={this.props.fullScreen}
          open={this.props.open}
          onClose={this.props.onClose}
        >
          <DialogTitle
            style={{ paddingBottom: 0 }}
            id="responsive-dialog-title"
          >
            <span className="booking__details__title__reservations">
              {title}
            </span>

            {isReservatiodPaid && (
              <span className="booking__details__paid"> (Confirmed)</span>
            )}
          </DialogTitle>

          <DialogContent>
            <ContactDetailsForm
              isPaid={isReservatiodPaid}
              iqosFriendly={iqosFriendly}
              pendingBooking={pendingBooking}
              active={formPage === 0}
              formValues={this.props.formValues}
              menuList={this.props.menuList}
              bookingTime={this.props.formValues.booking_time}
              updateBookingTime={this.props.changeBookingTime}
              updatePhoneNumber={this.props.changePhoneNumber}
              handleAttachedMenus={this.handleAttachedMenus}
              isPhoneNumberValid={this.state.isPhoneNumberValid}
              setIsPhoneNumberValid={value =>
                this.setState({ isPhoneNumberValid: value })
              }
            />
          </DialogContent>

          <DialogActions
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div>
              {formPage === 0 && (
                <Button onClick={this.closeForm} color="secondary">
                  Close
                </Button>
              )}

              {formPage === 0 && (
                <Button
                  onClick={
                    editMode ? this.editReservation : this.createReservation
                  }
                  color="primary"
                >
                  {editMode ? 'Save' : 'Create'}
                </Button>
              )}
            </div>
            {editMode && (
              <Button
                onClick={this.showDeleteConfirmation}
                className="delete__btn"
                color="primary"
                variant="contained"
                size="small"
              >
                Delete
              </Button>
            )}
          </DialogActions>

          <Loader loading={this.state.loading} />
        </Dialog>

        <ConfirmationDialog
          open={this.state.showDeleteConfirmation}
          confirmationTitle="Delete Deposits"
          confirmationDescription="You are about to delete this Deposits. Are you sure this is the action you wish to perform?"
          onClose={this.hideDeleteConfirmation}
          onConfirm={this.deleteReservation}
        />

        <ConfirmationDialog
          open={this.state.showRefundConfirmation}
          confirmationTitle="Refund Booking"
          confirmationDescription="You are about to refund this booking. Are you sure this is the action you wish to perform?"
          onClose={this.hideRefundConfirmation}
          onConfirm={this.refundBooking}
        />

        <ConfirmationDialog
          open={this.state.showDeleteWithRefundConfirmation}
          confirmationTitle="Apply Refund"
          confirmationDescription="Do you also wish to apply a refund to this booking before deleting it?"
          onClose={() => this.deleteBooking(false)}
          onConfirm={() => this.deleteBooking(true)}
        />
        {!editMode && (
          <Modal
            open={this.state.showModal}
            onClose={this.handleCloseModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div className="order-container">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    lineHeight: '32px !important',
                    textAlign: 'start',
                    display: 'flex',
                    marginBottom: '10px',
                    letterSpacing: '-0.5px',
                    fontSize: '24px',
                    color: '#000000',
                  }}
                >
                  Reservation Sent
                </h2>
                <button
                  onClick={this.handleCloseModal}
                  style={{
                    border: 'none',
                    background: 'none',
                    fontSize: '20px',
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <hr />
              <p>A reservation link has been sent to {customerName}'s phone.</p>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

const convertBookingToForm = (booking, currency, lastUsedDepositDetails) => {
  if (!booking) {
    booking = { menu: '' };
  }
  var depositDetails = {};

  if (booking.force_deposit) {
    const amount =
      booking.force_deposit.amount / multiplyValueForCurrency(currency);
    const apply_booking_fee = booking.force_deposit.apply_booking_fee;
    const booking_fee =
      booking.force_deposit.booking_fee / multiplyValueForCurrency(currency);
    const booking_fee_type = booking.force_deposit.booking_fee_type;

    depositDetails = {
      amount,
      apply_booking_fee,
      booking_fee,
      booking_fee_type,
    };
  } else if (lastUsedDepositDetails) {
    depositDetails = lastUsedDepositDetails;
  } else {
    // eslint-disable-next-line no-unused-vars
    depositDetails = {
      amount: 0,
      apply_booking_fee: false,
      booking_fee: 0,
      booking_fee_type: 'fixed',
    };
  }

  // const bookingMenu = booking.menu === '' ? '-' : booking.menu;
  return {
    name: booking.customer_name,
    phone: booking.phone_number,
    email: booking.email,
    notes: booking.notes,
    guest_count: booking.guest_count,
    booking_time: booking.reserved_from,
    amount: booking.deposit_amount / multiplyValueForCurrency(currency) || '',
    menu: booking.attached_menus,
  };
};

const mapStateToProps = (state, ownProps) => {
  const booking = ownProps.booking || undefined;
  const bookingReducer = state.booking;

  const initialValues = convertBookingToForm(
    booking,
    state.venue.currency,
    state.client.lastUsedDepositDetails
  );

  return {
    formValues: getFormValues('bookingDetails')(state) || {},
    formValid: isValid('bookingDetails')(state),
    initialValues: initialValues,
    lastUsedDepositDetails: state.client.lastUsedDepositDetails,
    bookingCreated: bookingReducer.bookingCreated,
    creatingBooking: bookingReducer.creatingBooking,
    creatingBookingErr: bookingReducer.creatingBookingErr,
    bookingEdited: bookingReducer.bookingEdited,
    editingBooking: bookingReducer.editingBooking,
    bookingDeleted: bookingReducer.bookingDeleted,
    deletingBooking: bookingReducer.deletingBooking,
    bookingRefunded: bookingReducer.bookingRefunded,
    refundingBooking: bookingReducer.refundingBooking,
    menuList: state.menu.menuList,
    venue: state.venue,
  };
};

const mapDispatchToProps = dispatch => ({
  createReservations: reservations =>
    dispatch(createReservations(reservations)),
  fetchAllMenus: () => dispatch(fetchAllMenus()),
  fetchMenuList: () => dispatch(fetchMenuList()),
  createBooking: booking => dispatch(createPendingBooking(booking)),
  deleteReservation: id => dispatch(deleteReservation(id)),
  updateReservation: reservation => dispatch(UpdateReservation(reservation)),
  editBooking: booking => dispatch(editBooking(booking)),
  deleteBooking: (id, applyRefund) => dispatch(deleteBooking(id, applyRefund)),
  refundBooking: id => dispatch(refundBooking(id)),
  showAlert: (title, desc) => dispatch(showAlert(title, desc)),
  setLastUsedDepositDetails: depositDetails =>
    dispatch(setLastUsedDepositDetails(depositDetails)),
  changeBookingTime: function (value) {
    return dispatch(change('bookingDetails', 'booking_time', value));
  },
  changePhoneNumber: phoneNumber =>
    dispatch(change('bookingDetails', 'phone', phoneNumber)),
});

BookingDetailsModal.propTypes = {
  booking: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  askForTime: PropTypes.bool.isRequired,
};

BookingDetailsModal = reduxForm({
  form: 'bookingDetails',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(BookingDetailsModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(BookingDetailsModal));



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/BookingDetailsModal/index.jsx